import React from 'react';
import MuiChip from '@mui/material/Chip';
export const Chip = ({ label, variant = 'outlined', color = 'primary', size = 'medium', startIcon = null, endIcon = null, onDelete, _sx, className = '', dataTestId, }) => {
    return (React.createElement(MuiChip, { label: label, variant: variant, color: color, size: size, icon: startIcon, deleteIcon: endIcon, onDelete: onDelete, sx: _sx, className: className, "data-testid": dataTestId }));
};
